<template>
  <mt-popup v-model="regionVisible" position="bottom" class="region-popup">
    <div class="title"><i class="gone" @click="confirmSelectCity()">完成</i></div>
    <mt-picker
      :slots="slots"
       @change="onValuesChange"
      valueKey="name"
    ></mt-picker>
  </mt-popup>
</template>

<script>
  import api from '@/api/store.js'
    export default {
        name: "witPicker",
      data(){
          return{
            province:'',//省
            city:'',//市
            provinceCode:'',//省级代码
            cityCode:'', //市级代码

            regionVisible:false,//弹出框是否可见
            regionInit:false,//禁止地区选择器自动初始化，picker组件会默认进行初始化，导致一进入页面就会默认选中一个初始3级地址
            slots: [
              {
                flex: 1,
                values: [], //省份数组
                className: 'slot1',
                textAlign: 'right'
              }, {
                divider: true,
                content: '-',
                className: 'slot2'
              }, {
                flex: 1,
                values: [],
                className: 'slot3',
                textAlign: 'left'
              }
            ],
            threeLevelAddress:[],
            oldCode:'',//mint-ui的bug,第二项无法高亮显示

            isMaskFirstClick : true  //没有点击确认之前是否通过mask点击关闭picker


          }
      },
      watch:{
        regionVisible(newVal){
          if(newVal===false){
            this.$emit('isMaskFirstClick',this.isMaskFirstClick)
          }

        }
      },
      methods:{
        /**
         * 点击确认之后触发的函数
         */
        confirmSelectCity(){
          //
          this.isMaskFirstClick = false

          this.regionVisible=false
           this.$emit('cityChange',{
             province:this.province,
             city:this.city,
             provinceCode:this.provinceCode,
             cityCode:this.cityCode,

           })
        },
        /**
         * 监听省市改变
         * @param picker
         * @param values
         */
        onValuesChange(picker, values) {

          //mint-ui的bug,第二项无法高亮显示

          if (this.regionInit){
            if(this.oldCode != values[0].code){

              //给市赋值
              picker.setSlotValues(1, this.getCityArr(values[0]["name"]));
            }

            this.oldCode = values[0].code

            //取值并赋值
            this.province = values[0]["name"];
            this.city = values[1]["name"];
            this.provinceCode = values[0]["code"];
            this.cityCode = values[1]["code"];


          }

        },
        /**
         * 遍历json，返回省级对象数组
         * @returns {Array}
         */
        getProvinceArr() {
          let provinceArr = [];
          this.threeLevelAddress.forEach(function (item) {
            let obj = {};
            obj.name = item.name;
            obj.code = item.code;
            provinceArr.push(obj);
          });
          return provinceArr;
        },
        /**
         * 遍历json，返回市级对象数组
         * @param province
         * @returns {Array}
         */
        getCityArr(province) {
          let cityArr = [];
          let flag = false;
          this.threeLevelAddress.forEach(function (item) {
            if (item.name === province) {
              flag =true;
              item.children.forEach(function (args) {
                let obj = {};
                obj.name = args.name;
                obj.code = args.code;
                cityArr.push(obj);
              });
            }
          });
          if(!flag){
            let obj = this.threeLevelAddress[0].children;
            obj.forEach((args)=>{
              let obj = {};
              obj.name = args.name;
              obj.code = args.code;
              cityArr.push(obj);
            })
          }
          return cityArr;
        },

        /**
         * 获得city数据
         */
        getCityData(){
          api.getCityData().then((data)=>{
            this.threeLevelAddress = data.data;
            this.slots[0].values = this.getProvinceArr();
            this.slots[2].values = this.getCityArr(this.slots[0].values);
            this.regionInit = true;
          })
        }
      },
      created(){
          this.getCityData();
      }
    }
</script>

<style scoped lang="scss">
@import "../../assets/css/global.scss";
  .region-popup{
      width: 100%;
    >.title{
      background: $color-bg-a;
      height: (74rem/$base);
      text-align: center;
      font-size: (24rem/$base);
      line-height: (74rem/$base);
      position: relative;
    }
    .gone{
      font-style: normal;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 100%;
      width: 50px;
      color: #ec6941;
      font-size: 14px;
      margin-right: 4px;
    }
  }
</style>
